import { Button, Icon, Result, Typography } from 'antd';
import React from 'react';

const { Paragraph, Text } = Typography;

const ErrorDisplay = ({ message }) => {
  return (
    <Result
      status="error"
      title="확인부탁드립니다."
      subTitle={message}
      extra={[
        <Button
          type="primary"
          key="console"
          onClick={() => {
            location.href = "http://pf.kakao.com/_APgfxd/chat";
          }}
        >
          카카오톡으로상담
        </Button>,
        <Button
          key="buy"
          onClick={() => {
            location.href = "tel:15449560";
          }}
        >
          고객센터 전화연결
        </Button>
      ]}
    >
      <div className="desc">
        <Paragraph>
          <Text
            strong={true}
            style={{
              fontSize: 16
            }}
          >
            도움이 필요하세요 ?
          </Text>
        </Paragraph>

        <Paragraph>
          <Icon style={{ color: "red" }} type="close-circle" /> 도움이 필요하신
          경우 아래 카카오톡 또는 유선상담을 통해 연락주시면 안내 도와
          드리겠습니다. 고객센터는 평일~토요일 오전9시~오후6시 까지 운영됩니다.
        </Paragraph>
      </div>
    </Result>
  );
};

export default ErrorDisplay;



// WEBPACK FOOTER //
// ./src/components/error/index.tsx